import { Typography } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";
import * as Sticker from "ds/Sticker";
import { semiBoldAlias, breakpoints } from "Libs/theme";

export const BillingDetailsContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;

  @media (min-width: ${breakpoints[1]}) {
    flex-direction: row-reverse;
    flex-wrap: wrap;
  }
`;

export const Aside = styled.aside`
  margin-top: 32px;
  @media (min-width: ${breakpoints[1]}) {
    flex-basis: 300px;
    margin: 0;
  }

  @media (min-width: ${breakpoints[2]}) {
    flex-basis: 25%;
    flex-grow: 1;
    flex-shrink: 1;
    margin: 0;
    max-width: 427px;
  }
`;

export const Content = styled.section`
  flex-direction: column;
  flex-basis: 100%;

  @media (min-width: ${breakpoints[1]}) {
    min-width: 350px;
    flex-basis: 200px;
    flex-grow: 1;
    flex-shrink: 1;
    margin-right: 32px;
  }

  @media (min-width: ${breakpoints[2]}) {
    flex-basis: 60%;
    flex-grow: 2;
  }
`;

export const PaymentMethodsSection = styled.section`
  span {
    line-height: 24px;
  }

  h3 > p {
    margin: 16px 0 8px;
  }
`;

export const InvoicesSection = styled.section``;

export const SectionBox = styled.div`
  border-radius: 4px;
  background-color: var(--section-snow-background-color, var(--snow));
  padding: 32px;
  box-sizing: border-box;
  flex: 1 1 0;
  width: 100%;
  margin-bottom: 32px;

  @media (min-width: ${breakpoints[0]}) {
    margin-right: 24px;
    &:last-of-type {
      margin-right: 0;
    }
  }

  @media (min-width: ${breakpoints[1]}) {
    margin-right: 32px;
    &:last-of-type {
      margin-right: 0;
    }
  }

  @media (min-width: ${breakpoints[2]}) {
    margin-bottom: 0;
  }

  > h3 {
    margin-top: 0;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  > p {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 16px;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  strong {
    display: block;
    font-size: 15px;
    line-height: 24px;
    ${semiBoldAlias()};
  }
  > span {
    display: block;
    font-size: 13px;
    color: var(--section-granite-color, var(--granite));
  }
  .field-card-number {
    .label {
      opacity: 1;
    }
  }
`;

export const SideSectionBox = styled(SectionBox)`
  margin-top: 16px;
  padding: 24px;
`;

export const SectionBoxTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HeaderLayout = styled.div`
  display: flex;
  margin-top: 4px;
  margin-bottom: 4px;
  align-items: baseline;
  color: var(--header-ebony-color, var(--ebony));
  height: 32px;

  @media (min-width: ${breakpoints[1]}) {
    flex-direction: row;
    margin: 32px 0 16px;
  }

  h3 {
    margin: 0;
    font-size: 15px;

    @media (min-width: ${breakpoints[0]}) {
      font-size: 18px;
    }
  }

  span {
    margin-left: 13px;
    font-size: 15px;
    &:first-letter {
      text-transform: uppercase;
    }

    @media (min-width: 768px) {
      margin-left: 0;
    }
  }
  > :nth-last-child(2) {
    flex-grow: 1;
  }
  a {
    text-decoration: none;
    font-weight: 600;
    margin-bottom: 16px;
  }
  button,
  button:active {
    margin: 0;
  }
  &.new-payment {
    h3 {
      flex-grow: 0;
    }
    span {
      flex-grow: 1;
    }
  }
`;

export const HeaderLayoutChangePayment = styled(HeaderLayout)`
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  margin: 0;

  span {
    margin-left: 0;
  }

  button {
    position: absolute;
    right: 0;
    top: 0;
  }

  h4 {
    margin: 0;
  }
`;

export const SectionHeader = styled.h4`
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
  padding: 0;
  margin: 0;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 32px;

  @media (min-width: ${breakpoints[2]}) {
    #billing-address-form {
      div[class=""],
      div:not([class]) {
        display: none;
      }
    }

    #billing-address-form > .vat_number {
      grid-row: 1000;
      grid-column: 1 / 3;
    }
  }

  @media (min-width: ${breakpoints[3]}) {
    flex: 1.75;
  }
`;

export const Illustration = styled.div`
  width: 100px;
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NoDetailsBox = styled.div`
  margin-top: 146px;
  margin-bottom: 146px;

  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SubscribeButton = styled(Button)`
  margin-top: 40px;
`;

export const SubscribeDescription = styled(Typography.BodyText)`
  margin-top: 24px;
  max-width: 655px;
  text-align: center;
`;

export const SubscribeTitle = styled(Typography.Title)`
  margin-top: 40px;
`;

export const TermsInfo = styled(Typography.BodyText)`
  margin-top: 126px;
  color: var(--text-neutral-weakest, #8b9397);
  text-align: center;
  font-size: 12px;
`;

export const TermsLink = styled(Button)`
  font-size: 12px;
`;

export const LoadingWrapper = styled.div`
  margin: 0 auto;
`;

export const PrepaymentSummaryWrapper = styled.div`
  margin-top: 0;
  display: flex;
  gap: 48px;

  ${Sticker.Root} + & {
    margin-top: 32px;
  }
`;

export const PrepaidFundsMessage = styled.p`
  color: var(--mode-text-neutral-default-weak);
  font-size: 14px;
  line-height: 24px;
  margin-top: 32px;
`;

export const TransactionsTable = styled.div`
  margin-top: 32px;
  display: grid;
  grid-template-columns: max-content 3fr 1fr max-content;
  gap: 8px 32px;
  overflow-x: scroll;

  & > :nth-child(4n) {
    text-align: right;
  }
`;

export const TransactionsTableDescription = styled.p`
  color: var(--mode-text-neutral-default-weak);
  font-size: 14px;
  line-height: 24px;
  margin: 0;
`;
